import React from "react";
import { Button, Container, Avatar, LinearProgress } from "@material-ui/core";
import {P1, P2, P3} from 'assets/fonts';


class TestMain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            maskVolume: this.props.volume,
            sourceVolume: this.props.volume,
            questions: [],
            index: 0,
            dbs: [0],
            time: 0,
            timer: [],
            userStart: false,
            alert: false,
            once: false,
            traversals: 0,
            lastCorrectness: null,
            stage: "loading",
            process: 0
        }
    }

    componentDidMount = async () => {
        let num = 0;
        for (var i = 1; i < 5; i++) {
            for (var j = 1; j < 9; j++) {
                const audio1 = new Audio(process.env.PUBLIC_URL + "/hearing/crm3-source-audio/" + i.toString() + j.toString() + ".wav");
                const audio2 = new Audio(process.env.PUBLIC_URL + "/hearing/crm3-loss-audio/" + i.toString() + j.toString() + ".wav");
                const audio3 = new Audio(process.env.PUBLIC_URL + "/hearing/crm3-mask-audio/" + i.toString() + j.toString() + ".wav");
                audio1.volume = 0;
                audio2.volume = 0;
                audio3.volume = 0;
                try {
                    num += 1;
                    await this.setState({ process: num });
                    await audio1.play();
                    await audio2.play();
                    await audio3.play();
                    await audio1.pause();
                    await audio2.pause();
                    await audio3.pause();
                } catch (e) { console.log(e, "for", i, j) }
            }
        }
        this.setState({ loading: false });
    }

    startTimer = () => {
        this.setState({ time: new Date().getTime() });
    };
    stopTimer = () => {
        this.setState({ time: new Date().getTime() - this.state.time });
    };
    resetTimer = () => {
        this.setState({ time: 0 });
    };

    componentDidUpdate = () => {
        if (this.state.time >= 5 && this.state.alert === false && this.state.once === false) {
            this.setState({ alert: true, once: true });
        }
    }

    playAudio = async () => {
        const { questions, maskVolume, sourceVolume } = this.state;
        const color = Math.ceil(Math.random() * 4).toString();
        const number = Math.ceil(Math.random() * 8).toString();
        const question = color + number
        const colorMask = Math.ceil(Math.random() * 4).toString();
        const numberMask = Math.ceil(Math.random() * 8).toString();
        const questionMask = colorMask + numberMask
        questions.push(question);
        this.setState({ questions });
        let sourceAudio = new Audio(process.env.PUBLIC_URL + "/hearing/crm3-source-audio/" + question + ".wav");
        let maskAudio = new Audio(process.env.PUBLIC_URL + "/hearing/crm3-mask-audio/" + questionMask + ".wav");
        sourceAudio.volume = sourceVolume;
        maskAudio.volume = 0.5 * maskVolume;
        await sourceAudio.play();
        setTimeout(() => maskAudio.play(), 300);
        setTimeout(() => {
            maskAudio.pause();
            this.startTimer();
            this.setState({ userStart: true });
        }, sourceAudio.duration * 1000);
    }

    handleClick = async (num) => {
        const { index, traversals } = this.state;
        await this.stopTimer();
        await this.resetTimer();
        await this.setState({ userStart: false });
        await this.setState({ index: index + 1, traversals: traversals + 1 });
        if (this.state.traversals >= 3) {
            this.setState({ stage: "done" });
        } else {
            setTimeout(() => {
                this.playAudio();
            }, 2000)
        }
    }

    handleCloseAlert = (event, reason) => {
        if (reason === "clickaway") return;
        this.setState({ alert: false });
    };

    render() {
        const { loading, userStart, stage, traversals, process } = this.state;
        const rows = ["", "", "", "", "", "", "", ""];
        return (
            <div>
                {
                    stage === "loading"
                        ?
                        <Container>
                            <div style={{ marginTop: "20%", marginLeft: "10%", marginRight: "10%" }}>
                                <P2>
                                    The following is an example of what you will experience during the experiment. 
                                    Listen for the call sign or name Baron. For example, “Ready Baron, go to red three now.” 
                                    Use your mouse and choose the red number 3 on the computer screen. 
                                    Please give this example a few minutes to load. A NEXT button will appear when the trial is ready to start.
                                </P2>
                                <br />
                                {
                                    loading ?
                                        <LinearProgress variant="determinate" value={Math.ceil(process / 32 * 100)} /> :
                                        <Button
                                            variant="contained"
                                            style={{ margin: 20, width: 150, color: "white", backgroundColor: "#107896" }}
                                            onClick={() => {
                                                this.setState({ stage: "test" });
                                                this.playAudio();
                                            }}
                                        >
                                            Next
                                </Button>
                                }
                            </div>


                        </Container>
                        :
                        stage === "done" ?
                            <Container>
                                <div style={{ marginTop: "20%", marginLeft: "10%", marginRight: "10%" }}>
                                    <P2>You are now ready to start the experiment. You are always listening for the call sign Baron.</P2>
                                    <P2>For example if you hear "Ready Baron, go to Blue 2 now," you should click on the blue 2. If you aren’t sure, make a guess!</P2>
                                    <P2>There is a pause button located beside the progress bar. You may pause the experiment between audio presentations. Click this button again to resume the experiment.</P2>
                                    <P2>Press NEXT when you are ready to start.</P2>
                                    <Button
                                        variant="contained"
                                        style={{ margin: 20, width: 150, color: "white", backgroundColor: "#107896" }}
                                        onClick={this.props.handleClick}
                                    >
                                        Next
                                </Button>
                                </div>

                            </Container>
                            :
                            <div>
                                <div id="buttons" style={{ position: "fixed", height: "80%", width: "100%", backgroundColor: "#C2CAD0" }}>
                                    <div className="row" style={{ height: "25%" }}>
                                        {rows.map((e, i) => <button disabled={!userStart} value={"1" + String(i+1)} onClick={(e) => this.handleClick(e.target.value)} style={{ color: "red", border: "none", background: "none", width: "12.5%", fontSize: 80 }}>{i+1}</button>)}
                                    </div>
                                    <div className="row" style={{ height: "25%" }}>
                                        {rows.map((e, i) => <button disabled={!userStart} value={"2" + String(i+1)} onClick={(e) => this.handleClick(e.target.value)} style={{ color: "green", border: "none", background: "none", width: "12.5%", fontSize: 80 }}>{i+1}</button>)}
                                    </div>
                                    <div className="row" style={{ height: "25%" }}>
                                        {rows.map((e, i) => <button disabled={!userStart} value={"3" + String(i+1)} onClick={(e) => this.handleClick(e.target.value)} style={{ color: "blue", border: "none", background: "none", width: "12.5%", fontSize: 80 }}>{i+1}</button>)}
                                    </div>
                                    <div className="row" style={{ height: "25%" }}>
                                        {rows.map((e, i) => <button disabled={!userStart} value={"4" + String(i+1)} onClick={(e) => this.handleClick(e.target.value)} style={{ color: "white", border: "none", background: "none", width: "12.5%", fontSize: 80 }}>{i+1}</button>)}
                                    </div>
                                </div>
                                <div id="progress" className="row" style={{ position: "fixed", left: "20%", bottom: 10 }}>
                                    <P2>Progress⠀</P2>
                                    <Avatar style={{ width: 20, height: 20, border: "solid", borderColor: "#107896", backgroundColor: traversals > 0 ? "#107896" : "white" }}>⠀</Avatar>
                                    <Avatar style={{ width: 20, height: 20, border: "solid", borderColor: "#107896", backgroundColor: traversals > 1 ? "#107896" : "white" }}>⠀</Avatar>
                                    <Avatar style={{ width: 20, height: 20, border: "solid", borderColor: "#107896", backgroundColor: traversals > 2 ? "#107896" : "white" }}>⠀</Avatar>
                                </div>
                            </div>
                }
            </div>
        )
    }
}

export default TestMain;